import { render, staticRenderFns } from "./InputToken.vue?vue&type=template&id=24bf5ab9"
import script from "./InputToken.vue?vue&type=script&lang=js"
export * from "./InputToken.vue?vue&type=script&lang=js"
import style0 from "./InputToken.vue?vue&type=style&index=0&id=24bf5ab9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports